import ErrorPageContainer from './ErrorPageContainer';

export default ErrorPageContainer;
